import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

export interface PriceNextProps {
  className?: string;
  tradeWay?: ReactNode;
  solveMode?: ReactNode;
  shareButton?: ReactNode;
  errorTop?: ReactNode;
  errorPanel?: ReactNode;
  solveResult?: ReactNode;
  fxSpot?: ReactNode;
  solveRatio?: ReactNode;
  blinker?: ReactNode;
  flowWay?: ReactNode;
  countDownBar?: ReactNode;
  quoteStatus?: ReactNode;
  pricedOn?: ReactNode;
  quoteYield?: ReactNode;
}

export const PriceNext: FC<PriceNextProps> = ({
  className,
  tradeWay,
  solveMode,
  shareButton,
  errorTop,
  errorPanel,
  solveResult,
  fxSpot,
  solveRatio,
  blinker,
  flowWay,
  countDownBar,
  quoteStatus,
  pricedOn,
  quoteYield,
}) => {
  const { formatMessage } = useIntl();
  return (
    <div className={classNames(className, 'd-flex flex-column rounded-1 mx-3 overflow-hidden')}>
      <div className="d-flex flex-column">
        <div style={{ minHeight: 52 }} className="d-flex justify-content-between">
          <div className="d-flex flex-column px-12px pt-12px gap-1">
            <div className="fw-semibold" title={formatMessage({ id: 'tradeWay' })}>
              {tradeWay}
            </div>
            <div className="fw-semibold lh-1" data-e2e="solving-mode">
              {solveMode}
              {errorTop}
            </div>
          </div>
          <div className="d-flex p-2" title={formatMessage({ id: 'form.buttons.Share' })}>
            {shareButton}
          </div>
        </div>
        <div style={{ minHeight: 88 }} className="d-flex justify-content-between">
          <div className="d-flex flex-grow-1 align-items-end">
            <div className="d-flex flex-column flex-grow-1 px-12px py-2">
              <div>{errorPanel}</div>
              <div title={formatMessage({ id: 'solveValue' })}>{solveResult}</div>
              <div>{fxSpot}</div>
              <div>{quoteYield}</div>
              <div>{solveRatio}</div>
              {blinker && <div className="p-1">{blinker}</div>}
            </div>
            <div className="flex-shrink-1 align-self-end px-12px py-2">
              <div className="d-flex flex-column align-items-end gap-1">
                {flowWay}
                {pricedOn && (
                  <div data-e2e="priced-on" title={formatMessage({ id: 'sidePanel.pricedOn' })}>
                    {pricedOn}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {countDownBar ?? <div className="border-top border-opacity-40" />}
      {quoteStatus && (
        <div style={{ height: 40 }} className="d-flex p-0" title={formatMessage({ id: 'sidePanel.status.title' })}>
          {quoteStatus}
        </div>
      )}
    </div>
  );
};
